"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return LineGroup;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
const _Group = require("../Group");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
// https://stackoverflow.com/a/70985651
// https://stackoverflow.com/a/67793914
function getValidPoints(points = []) {
    const [start, finish] = points;
    if (start.x === finish.x) {
        finish.x += 1;
    }
    if (start.y === finish.y) {
        finish.y += 1;
    }
    return [
        start,
        finish
    ];
}
class LineGroup extends _Group.ShapeGroup {
    _childAttributes() {
        // Optionally register subclass attributes here.
        const nullPoint = {
            x: null,
            y: null
        };
        this.start = nullPoint;
        this.finish = nullPoint;
        this.midpointX = nullPoint;
        this.midpointY = nullPoint;
    }
    _unpack(shape = {}, config = {}) {
        const { points = [] } = shape;
        const [start, finish] = getValidPoints(points);
        this.start = start;
        this.finish = finish;
        this.midpointX = (start.x + finish.x) / 2;
        this.midpointY = (start.y + finish.y) / 2;
    }
    _init(shape = {}, config = {}) {
        this.node = new _konva.default.Line(_object_spread({
            id: shape.id,
            points: [
                this.start.x,
                this.start.y,
                this.finish.x,
                this.finish.y
            ],
            stroke: "white",
            strokeWidth: 2,
            tension: 1,
            draggable: this.draggable,
            hitStrokeWidth: 10
        }, config));
    }
    _update(shape = {}, config = {}) {
        this.node.setAttrs({
            points: [
                this.start.x,
                this.start.y,
                this.finish.x,
                this.finish.y
            ]
        });
    }
    _labelConfig() {
        return {
            points: [
                {
                    x: this.midpointX,
                    y: this.midpointY
                }
            ]
        };
    }
    _stroke() {
        const strokeWidth = 2;
        const dx = this.finish.x - this.start.x;
        const dy = this.finish.y - this.start.y;
        const rotation = Math.atan2(dy, dx) * 180 / Math.PI;
        const width = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) + strokeWidth;
        const offset = {
            x: Math.round(strokeWidth / 2),
            y: strokeWidth
        };
        return new _konva.default.Rect({
            name: "line-stroke",
            position: this.start,
            offset,
            rotation,
            width,
            height: 4,
            stroke: "black",
            listening: false
        });
    }
}
